var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    width: 0,
    height: 0,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">\n\t", _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-alert",
    viewBox: "0 0 22.955 20.103",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle",
    transform: "translate(-0.524 -1.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5774",
    "data-name": "Pfad 5774",
    d: "M10.29,3.86,1.82,18a2,2,0,0,0,1.71,3H20.47a2,2,0,0,0,1.71-3L13.71,3.86a2,2,0,0,0-3.42,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_189",
    "data-name": "Linie 189",
    y2: 4,
    transform: "translate(12 9)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_190",
    "data-name": "Linie 190",
    y1: 1.603,
    transform: "translate(12 15.397)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 20.401 20.401",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(0.75 1.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5775",
    "data-name": "Pfad 5775",
    d: "M18.732,13.909v4.964a1.859,1.859,0,0,1-1.859,1.859H3.859A1.859,1.859,0,0,1,2,18.873V5.859A1.859,1.859,0,0,1,3.859,4H8.823",
    transform: "translate(-2 -2.141)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5776",
    "data-name": "Pfad 5776",
    d: "M17.3,2l3.718,3.718-9.3,9.3H8V11.3Z",
    transform: "translate(-2.423 -2)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-duplicate",
    viewBox: "0 0 20.5 19.665",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2394",
    "data-name": "Rechteck 2394",
    width: 12,
    height: 12,
    rx: 2,
    transform: "translate(7 6.165)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5782",
    "data-name": "Pfad 5782",
    d: "M4.789,14.084h-.93A1.859,1.859,0,0,1,2,12.225V3.859A1.859,1.859,0,0,1,3.859,2h8.366a1.859,1.859,0,0,1,1.859,1.859v.93",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-compare",
    viewBox: "0 0 18.853 19.466",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repeat",
    transform: "translate(1.061 0.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5779",
    "data-name": "Pfad 5779",
    d: "M17,2.1l3.718,3.718L17,9.536",
    transform: "translate(-3.986 -2.1)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5780",
    "data-name": "Pfad 5780",
    d: "M3,11.777V9.918A3.718,3.718,0,0,1,6.718,6.2h11.9M6.718,20.794,3,17.076l3.718-3.718",
    transform: "translate(-3 -2.389)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5781",
    "data-name": "Pfad 5781",
    d: "M19.816,11.8v1.859A3.718,3.718,0,0,1,16.1,17.377H4.2",
    transform: "translate(-3.085 -2.783)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-delete",
    viewBox: "0 0 16.732 20.091",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5777",
    "data-name": "Pfad 5777",
    d: "M3,6H19.732",
    transform: "translate(-3 -2.282)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5778",
    "data-name": "Pfad 5778",
    d: "M18.014,5.718V18.732a1.859,1.859,0,0,1-1.859,1.859h-9.3A1.859,1.859,0,0,1,5,18.732V5.718m2.789,0V3.859A1.859,1.859,0,0,1,9.648,2h3.718a1.859,1.859,0,0,1,1.859,1.859V5.718",
    transform: "translate(-3.141 -2)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_191",
    "data-name": "Linie 191",
    y2: 5,
    transform: "translate(6.07 8.591)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_192",
    "data-name": "Linie 192",
    y2: 5,
    transform: "translate(10.07 8.591)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-share",
    viewBox: "0 0 19.5 21.5",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(-2.25 -1.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(15 2)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(3 9)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(15 16)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_193",
    "data-name": "Linie 193",
    x2: 6.83,
    y2: 3.98,
    transform: "translate(8.59 13.51)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_194",
    "data-name": "Linie 194",
    x1: 6.82,
    y2: 3.98,
    transform: "translate(8.59 6.51)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-language",
    viewBox: "0 0 18.735 18.735",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-language",
    "data-name": "Icon material-language",
    d: "M12.358,3a9.368,9.368,0,1,0,9.377,9.368A9.363,9.363,0,0,0,12.358,3ZM18.85,8.621H16.087a14.66,14.66,0,0,0-1.293-3.335A7.522,7.522,0,0,1,18.85,8.621Zm-6.482-3.71a13.2,13.2,0,0,1,1.789,3.71H10.578A13.2,13.2,0,0,1,12.368,4.911Zm-7.251,9.33a7.328,7.328,0,0,1,0-3.747H8.283a15.471,15.471,0,0,0-.131,1.874,15.471,15.471,0,0,0,.131,1.874Zm.768,1.874H8.649A14.66,14.66,0,0,0,9.941,19.45,7.482,7.482,0,0,1,5.885,16.115ZM8.649,8.621H5.885A7.482,7.482,0,0,1,9.941,5.286,14.66,14.66,0,0,0,8.649,8.621Zm3.719,11.2a13.2,13.2,0,0,1-1.789-3.71h3.578A13.2,13.2,0,0,1,12.368,19.824Zm2.192-5.583H10.176a13.782,13.782,0,0,1-.15-1.874,13.663,13.663,0,0,1,.15-1.874H14.56a13.663,13.663,0,0,1,.15,1.874A13.782,13.782,0,0,1,14.56,14.241Zm.234,5.208a14.66,14.66,0,0,0,1.293-3.335H18.85a7.522,7.522,0,0,1-4.056,3.335Zm1.658-5.208a15.471,15.471,0,0,0,.131-1.874,15.471,15.471,0,0,0-.131-1.874h3.166a7.328,7.328,0,0,1,0,3.747Z",
    transform: "translate(-3 -3)",
    fill: "currentColor"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 15.012 15.012",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-up-right",
    d: "M7,20.731,19.633,8.1m1.1,12.633V7H7",
    transform: "translate(-6.47 -6.25)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow2",
    viewBox: "0 0 8.219 14.316",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5729",
    "data-name": "Pfad 5729",
    d: "M1441.5-857.737l6.628,6.628,6.628-6.628",
    transform: "translate(858.268 1455.286) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 13.082 13.435",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6700",
    "data-name": "Gruppe 6700",
    transform: "translate(-1541 -117.646)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2168",
    "data-name": "Rechteck 2168",
    width: 1.5,
    height: 17,
    transform: "translate(1553.021 118) rotate(45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2169",
    "data-name": "Rechteck 2169",
    width: 1.5,
    height: 17,
    transform: "translate(1541 118.707) rotate(-45)",
    fill: "currentColor"
  })))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close2",
    viewBox: "0 0 8.263 8.524",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6700",
    "data-name": "Gruppe 6700",
    transform: "translate(-1560.999 -559.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2168",
    "data-name": "Rechteck 2168",
    width: 1,
    height: 10.685,
    transform: "translate(1568.555 560.012) rotate(45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2169",
    "data-name": "Rechteck 2169",
    width: 1,
    height: 10.685,
    transform: "translate(1561 560.457) rotate(-45)",
    fill: "currentColor"
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 11.948 9.205",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_313",
    "data-name": "Pfad 313",
    d: "M1220.086-969.444l3.371,3.371,7.513-7.614",
    transform: "translate(-1219.556 974.213)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-visible",
    viewBox: "0 0 23.677 17.5",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.161 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,12S5,4,12,4s11,8,11,8-4,8-11,8S1,12,1,12Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-invisible",
    viewBox: "0 0 23.677 22.034",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1715.161 -325.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1715 325)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 5757",
    d: "M1,12S5,4,12,4s11,8,11,8-4,8-11,8S1,12,1,12Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 141",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    "data-name": "Linie 187",
    x1: 20,
    y2: 21,
    transform: "translate(1716.5 326.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 21.79 22.021",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 140",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(3 3)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    "data-name": "Linie 159",
    x1: 6.85,
    y1: 7.1,
    transform: "translate(16.65 16.65)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 19.5 20.75",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-2.25 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rechteck 2347",
    width: 18,
    height: 18,
    transform: "translate(3 4)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    "data-name": "Linie 160",
    y2: 4,
    transform: "translate(16 2)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    "data-name": "Linie 161",
    y2: 4,
    transform: "translate(8 2)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    "data-name": "Linie 162",
    x2: 18,
    transform: "translate(3 10)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info",
    viewBox: "0 0 4 12",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 6578",
    transform: "translate(-919 -835.579)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rechteck 2413",
    transform: "translate(919 839.579)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rechteck 2415",
    transform: "translate(919 845.579)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rechteck 2414",
    transform: "translate(922 839.579) rotate(90)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rechteck 2417",
    transform: "translate(922 835.579) rotate(90)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 1,
    fill: "none"
  }))))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-resize-container",
    viewBox: "0 0 23.369 81.373",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 5761",
    d: "M-11573.672-4681.139l-17.4-22.369h-44.523l-17.4,22.369Z",
    transform: "translate(4704.008 -11572.649) rotate(-90)",
    fill: "currentColor",
    stroke: "#cacacd",
    strokeWidth: 1
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-resize-arrows",
    viewBox: "0 0 17.743 24.298",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6516",
    "data-name": "Gruppe 6516",
    transform: "translate(-1386.938 -491.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5752",
    "data-name": "Pfad 5752",
    d: "M-11274.373,1898.2l7.619-7.619,7.618,7.619",
    transform: "translate(3294.205 11774.754) rotate(90)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5764",
    "data-name": "Pfad 5764",
    d: "M0,0,7.619,7.618,15.237,0",
    transform: "translate(1395.617 492.381) rotate(90)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-more",
    viewBox: "0 0 15.944 8.68",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5718",
    "data-name": "Pfad 5718",
    d: "M-11274.373,1898.2l7.619-7.619,7.618,7.619",
    transform: "translate(11274.727 -1889.878)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-less",
    viewBox: "0 0 15.944 8.68",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5719",
    "data-name": "Pfad 5719",
    d: "M-11274.373,1890.585l7.619,7.619,7.618-7.619",
    transform: "translate(11274.727 -1890.231)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    viewBox: "0 0 27.754 33.979",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6686",
    "data-name": "Gruppe 6686",
    transform: "translate(-764 -527.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pfad_5796",
    "data-name": "Pfad 5796",
    transform: "translate(3398.23 13441.32)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2606.476-12879.83h-27.755v-33.979h18.772l8.983,8.992Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -2608.475830078125 -12881.830078125 L -2608.475830078125 -12903.9892578125 L -2616.287841796875 -12911.8095703125 L -2632.230712890625 -12911.8095703125 L -2632.230712890625 -12881.830078125 L -2608.475830078125 -12881.830078125 M -2606.475830078125 -12879.830078125 L -2634.230712890625 -12879.830078125 L -2634.230712890625 -12913.8095703125 L -2615.458740234375 -12913.8095703125 L -2606.475830078125 -12904.8173828125 L -2606.475830078125 -12879.830078125 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M3,12.493v3.2a1.6,1.6,0,0,0,1.6,1.6H15.791a1.6,1.6,0,0,0,1.6-1.6v-3.2m-3.2-4.8-4,4-4-4m4,3.038V2.5",
    transform: "translate(767.683 534.605)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-listarrow",
    viewBox: "0 0 14.314 8.219",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_320",
    "data-name": "Pfad 320",
    d: "M1441.5-857.737l6.628,6.628,6.628-6.628",
    transform: "translate(-1440.971 858.268)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star",
    viewBox: "0 0 31.5 29.25",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6403",
    "data-name": "Gruppe 6403",
    transform: "translate(-1449 -810)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-outline",
    "data-name": "Icon ionic-ios-star-outline",
    d: "M32.555,13.5H22.212L19.069,4.12a1.139,1.139,0,0,0-2.138,0L13.788,13.5H3.375A1.128,1.128,0,0,0,2.25,14.625a.827.827,0,0,0,.021.19,1.081,1.081,0,0,0,.471.795l8.5,5.991L7.98,31.085a1.128,1.128,0,0,0,.387,1.266A1.088,1.088,0,0,0,9,32.625a1.378,1.378,0,0,0,.7-.253L18,26.459l8.3,5.913a1.318,1.318,0,0,0,.7.253,1.01,1.01,0,0,0,.626-.274,1.114,1.114,0,0,0,.387-1.266L24.75,21.6l8.43-6.047.2-.176a1.18,1.18,0,0,0,.366-.752A1.191,1.191,0,0,0,32.555,13.5ZM23.611,20a1.975,1.975,0,0,0-.717,2.236l2.116,6.166a.282.282,0,0,1-.429.323l-5.442-3.881a1.965,1.965,0,0,0-1.146-.366,1.928,1.928,0,0,0-1.139.366l-5.442,3.874a.281.281,0,0,1-.429-.323L13.1,22.233a1.981,1.981,0,0,0-.724-2.25l-5.7-4.015a.283.283,0,0,1,.162-.513h6.94a1.966,1.966,0,0,0,1.863-1.343l2.081-6.2a.283.283,0,0,1,.534,0l2.081,6.2A1.966,1.966,0,0,0,22.2,15.455h6.841a.278.278,0,0,1,.162.506Z",
    transform: "translate(1446.75 806.625)"
  })))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-assistance",
    viewBox: "0 0 27.859 27.476",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6405",
    "data-name": "Gruppe 6405",
    transform: "translate(-1449.997 -993.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5608",
    "data-name": "Pfad 5608",
    d: "M28.442,14.549v1.17A12.721,12.721,0,1,1,20.9,4.093",
    transform: "translate(1448 991.568)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5609",
    "data-name": "Pfad 5609",
    d: "M30.037,6,17.316,18.734,13.5,14.917",
    transform: "translate(1446.405 991.111)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 23 23",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6406",
    "data-name": "Gruppe 6406",
    transform: "translate(-1455 -1086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5610",
    "data-name": "Pfad 5610",
    d: "M18,7.5v21",
    transform: "translate(1448.5 1079.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5611",
    "data-name": "Pfad 5611",
    d: "M7.5,18h21",
    transform: "translate(1448.5 1079.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-view",
    viewBox: "0 0 35 26",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6407",
    "data-name": "Gruppe 6407",
    transform: "translate(-1448 -1176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5612",
    "data-name": "Pfad 5612",
    d: "M1.5,18S7.5,6,18,6,34.5,18,34.5,18,28.5,30,18,30,1.5,18,1.5,18Z",
    transform: "translate(1447.5 1171)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5613",
    "data-name": "Pfad 5613",
    d: "M22.5,18A4.5,4.5,0,1,1,18,13.5,4.5,4.5,0,0,1,22.5,18Z",
    transform: "translate(1447.5 1171)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrows",
    viewBox: "0 0 15.944 14.68",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6703",
    "data-name": "Gruppe 6703",
    transform: "translate(3096.973 8589.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5718",
    "data-name": "Pfad 5718",
    d: "M-11274.373,1898.2l7.619-7.619,7.618,7.619",
    transform: "translate(8177.754 -10479.203)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5801",
    "data-name": "Pfad 5801",
    d: "M-11274.373,1898.2l7.619-7.619,7.618,7.619",
    transform: "translate(8177.754 -10473.203)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-subelement-arrow",
    viewBox: "0 0 13.414 8.122",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5828",
    "data-name": "Pfad 5828",
    d: "M-11274.372,1890.585l6,6,6-6",
    transform: "translate(11275.079 -1889.878)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-rotation",
    viewBox: "0 0 11.65 13.844",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-rotate-right",
    "data-name": "Icon material-rotate-right",
    d: "M14.447,4.827,11.119,1.5V3.745a5.845,5.845,0,0,0,0,11.6V13.867a4.383,4.383,0,0,1,0-8.644V8.082Zm3.2,3.986a5.782,5.782,0,0,0-1.185-2.845L15.427,7.007a4.246,4.246,0,0,1,.746,1.806Zm-5.068,5.046v1.477a5.8,5.8,0,0,0,2.852-1.177l-1.053-1.053A4.231,4.231,0,0,1,12.582,13.859Zm2.845-1.77,1.038,1.031a5.782,5.782,0,0,0,1.185-2.845H16.173A4.313,4.313,0,0,1,15.427,12.089Z",
    transform: "translate(-6 -1.5)",
    fill: "currentColor"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bug",
    viewBox: "0 0 22.955 20.103",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle",
    transform: "translate(-0.524 -1.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5774",
    "data-name": "Pfad 5774",
    d: "M10.29,3.86,1.82,18a2,2,0,0,0,1.71,3H20.47a2,2,0,0,0,1.71-3L13.71,3.86a2,2,0,0,0-3.42,0Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_189",
    "data-name": "Linie 189",
    y2: 4,
    transform: "translate(12 9)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_190",
    "data-name": "Linie 190",
    y1: 1.603,
    transform: "translate(12 15.397)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-favorite",
    viewBox: "0 0 23 20.81",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_16",
    "data-name": "Polygon 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.91036415100098 19.8800220489502 L 11.7319803237915 16.64407157897949 L 11.5 16.5225715637207 L 11.2680196762085 16.64407157897949 L 5.089635372161865 19.8800220489502 L 6.407959938049316 13.32732200622559 L 6.464479923248291 13.04640197753906 L 6.250659942626953 12.85562229156494 L 1.159917235374451 8.313380241394043 L 8.109370231628418 7.482312202453613 L 8.378350257873535 7.450152397155762 L 8.498310089111328 7.207252502441406 L 11.5 1.129178047180176 L 14.50168991088867 7.207252502441406 L 14.62164974212646 7.450152397155762 L 14.89062976837158 7.482312202453613 L 21.8400821685791 8.313380241394043 L 16.74934005737305 12.85562229156494 L 16.53552055358887 13.04640197753906 L 16.59203910827637 13.32732200622559 L 17.91036415100098 19.8800220489502 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5 2.258354187011719 L 8.706709861755371 7.91444206237793 L 2.319852828979492 8.678236961364746 L 7.011170387268066 12.86409187316895 L 5.786659240722656 18.95052719116211 L 11.5 15.95814228057861 L 17.21334075927734 18.95052719116211 L 15.98883056640625 12.86409187316895 L 20.68014717102051 8.678236961364746 L 14.29329013824463 7.91444206237793 L 11.5 2.258354187011719 M 11.5 1.9073486328125e-06 L 14.94999980926514 6.985852241516113 L 23 7.948532104492188 L 17.08222007751465 13.22870254516602 L 18.60738945007324 20.80952262878418 L 11.5 17.08700180053711 L 4.392610549926758 20.80952262878418 L 5.917779922485352 13.22870254516602 L 0 7.948532104492188 L 8.050000190734863 6.985852241516113 L 11.5 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "currentColor"
  })))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-favorite-filled",
    viewBox: "0 0 23 20.81",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_19",
    "data-name": "Polygon 19",
    d: "M11.5,0l3.45,6.986L23,7.949l-5.918,5.28,1.525,7.581L11.5,17.087,4.393,20.81l1.525-7.581L0,7.949l8.05-.963Z",
    fill: "currentColor"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-spinner",
    viewBox: "0 0 55 55",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamlinehq-loading-interface-essential-48",
    transform: "translate(1.75 1.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5834",
    "data-name": "Pfad 5834",
    d: "M12,.747V9.08",
    transform: "translate(13.75)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5835",
    "data-name": "Pfad 5835",
    d: "M12,27.83V19.5",
    transform: "translate(13.75 22.917)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5836",
    "data-name": "Pfad 5836",
    d: "M4.045,4.042,9.938,9.935",
    transform: "translate(4.027 4.027)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5837",
    "data-name": "Pfad 5837",
    d: "M23.2,23.192,17.3,17.3",
    transform: "translate(20.231 20.233)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5838",
    "data-name": "Pfad 5838",
    d: "M.75,12H9.083",
    transform: "translate(0 13.75)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5839",
    "data-name": "Pfad 5839",
    d: "M27.833,12H19.5",
    transform: "translate(22.917 13.75)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5840",
    "data-name": "Pfad 5840",
    d: "M4.045,23.192,9.938,17.3",
    transform: "translate(4.027 20.233)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5841",
    "data-name": "Pfad 5841",
    d: "M23.2,4.042,17.3,9.935",
    transform: "translate(20.231 4.027)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close-documentHints",
    viewBox: "0 0 12.729 12.728",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6590",
    "data-name": "Gruppe 6590",
    transform: "translate(-1860 -29.636)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2168",
    "data-name": "Rechteck 2168",
    width: 1,
    height: 17,
    transform: "translate(1872.021 29.636) rotate(45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2169",
    "data-name": "Rechteck 2169",
    width: 1,
    height: 17,
    transform: "translate(1860 30.343) rotate(-45)",
    fill: "currentColor"
  })))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down",
    viewBox: "0 0 16.298 9.21",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5719",
    "data-name": "Pfad 5719",
    d: "M-11274.373,1890.585l7.619,7.619,7.618-7.619",
    transform: "translate(11274.903 -1890.054)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-prev",
    viewBox: "0 0 9.21 16.298",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5805",
    "data-name": "Pfad 5805",
    d: "M0,7.619,7.619,0l7.618,7.619",
    transform: "translate(1.061 15.768) rotate(-90)",
    fill: "none",
    stroke: "#161d1b",
    strokeWidth: 1.5
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-next",
    viewBox: "0 0 9.21 16.298",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5804",
    "data-name": "Pfad 5804",
    d: "M-11274.373,1890.585l7.619,7.619,7.618-7.619",
    transform: "translate(-1890.054 -11258.605) rotate(-90)",
    fill: "none",
    stroke: "#161d1b",
    strokeWidth: 1.5
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-revision",
    viewBox: "0 0 20 20",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5806",
    "data-name": "Pfad 5806",
    d: "M2.5,2V7.16H7.66M18.841,19.2v-5.16h-5.16",
    transform: "translate(-0.07 -0.01)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5807",
    "data-name": "Pfad 5807",
    d: "M19.2,10.161a8.6,8.6,0,0,0-16.169-3.7M2,11.021a8.6,8.6,0,0,0,16.169,3.612",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drag",
    viewBox: "0 0 9 17",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6730",
    "data-name": "Gruppe 6730",
    transform: "translate(-693 -492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6728",
    "data-name": "Gruppe 6728",
    transform: "translate(-799 86)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1492 413)",
    fill: "#161d1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1492 420)",
    fill: "#161d1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1492 406)",
    fill: "#161d1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6729",
    "data-name": "Gruppe 6729",
    transform: "translate(-793 86)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154-2",
    "data-name": "Ellipse 154",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1492 413)",
    fill: "#161d1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155-2",
    "data-name": "Ellipse 155",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1492 420)",
    fill: "#161d1b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156-2",
    "data-name": "Ellipse 156",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1492 406)",
    fill: "#161d1b"
  }))))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 18.459 18.839",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-4.157 -5.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5843",
    "data-name": "Pfad 5843",
    d: "M10.2,13.833A4.759,4.759,0,1,0,5.445,9.074,4.759,4.759,0,0,0,10.2,13.833Z",
    transform: "translate(3.183 1.99)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5844",
    "data-name": "Pfad 5844",
    d: "M3.483,16.081a9.521,9.521,0,0,1,16.26,0",
    transform: "translate(1.774 7.162)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-register",
    viewBox: "0 0 19.138 19.431",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6882",
    "data-name": "Gruppe 6882",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5858",
    "data-name": "Pfad 5858",
    d: "M19.934,2.254l1.793,2.391H15.749",
    transform: "translate(11.05 23.08) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5859",
    "data-name": "Pfad 5859",
    d: "M21,7.645l1.793-2.391",
    transform: "translate(10.442 24.144) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5860",
    "data-name": "Pfad 5860",
    d: "M3.75,3.145A2.391,2.391,0,1,0,6.141.754,2.391,2.391,0,0,0,3.75,3.145Z",
    transform: "translate(-0.609)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5861",
    "data-name": "Pfad 5861",
    d: "M5.533,7.5A4.783,4.783,0,0,0,.75,12.283v1.793a1.2,1.2,0,0,0,1.2,1.2h1.2v3.587a1.2,1.2,0,0,0,1.2,1.2H6.728a1.2,1.2,0,0,0,1.2-1.2V15.272h1.2a1.2,1.2,0,0,0,1.2-1.2V12.283A4.783,4.783,0,0,0,5.533,7.5Z",
    transform: "translate(0 -1.369)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-login",
    viewBox: "0 0 19.897 18.668",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6880",
    "data-name": "Gruppe 6880",
    transform: "translate(0.003 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5851",
    "data-name": "Pfad 5851",
    d: "M7.5,12H20.376",
    transform: "translate(-1.232 -1.917)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5852",
    "data-name": "Pfad 5852",
    d: "M19.5,14.385l3.066-3.066L19.5,8.254",
    transform: "translate(-3.422 -1.232)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5853",
    "data-name": "Pfad 5853",
    d: "M13.013,13.763v3.679A1.175,1.175,0,0,1,11.9,18.668H1.864A1.175,1.175,0,0,1,.75,17.442V2.726A1.174,1.174,0,0,1,1.864,1.5H11.9a1.175,1.175,0,0,1,1.115,1.226V6.405",
    transform: "translate(0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-archive",
    viewBox: "0 0 18.117 18.105",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6879",
    "data-name": "Gruppe 6879",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5854",
    "data-name": "Pfad 5854",
    d: "M17.346,11.34a.738.738,0,0,0-.723-.881H7.892a.738.738,0,0,1-.722-.591L6.964,8.842a.738.738,0,0,0-.722-.591H1.486a.738.738,0,0,0-.722.881l1.914,9.6a.738.738,0,0,0,.722.591H15.151a.738.738,0,0,0,.722-.591C16.176,17.214,16.986,13.136,17.346,11.34Z",
    transform: "translate(0 -1.964)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5855",
    "data-name": "Pfad 5855",
    d: "M4.5,4.072l.015-2.584A.738.738,0,0,1,5.253.75h9.569a.738.738,0,0,1,.738.738l.015,4.8",
    transform: "translate(-0.982 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5856",
    "data-name": "Pfad 5856",
    d: "M7.512,3.742l6.081.006",
    transform: "translate(-1.77 -0.783)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5857",
    "data-name": "Pfad 5857",
    d: "M12,6.75h2.768",
    transform: "translate(-2.945 -1.571)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    viewBox: "0 0 19.897 18.668",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6878",
    "data-name": "Gruppe 6878",
    transform: "translate(19.894 19.418) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5851",
    "data-name": "Pfad 5851",
    d: "M7.5,12H20.376",
    transform: "translate(-1.232 -1.917)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5852",
    "data-name": "Pfad 5852",
    d: "M19.5,14.385l3.066-3.066L19.5,8.254",
    transform: "translate(-3.422 -1.232)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5853",
    "data-name": "Pfad 5853",
    d: "M13.013,13.763v3.679A1.175,1.175,0,0,1,11.9,18.668H1.864A1.175,1.175,0,0,1,.75,17.442V2.726A1.174,1.174,0,0,1,1.864,1.5H11.9a1.175,1.175,0,0,1,1.115,1.226V6.405",
    transform: "translate(0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-remove-from-folder",
    viewBox: "0 0 18.11 18.11",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamlinehq-interface-file-remove-alternate-interface-essential-14",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5865",
    "data-name": "Pfad 5865",
    d: "M2.5,9.444V1.778A1.278,1.278,0,0,1,3.778.5h6.388l6.388,6.388v8.944a1.278,1.278,0,0,1-1.278,1.278H7.611",
    transform: "translate(0.555 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5866",
    "data-name": "Pfad 5866",
    d: "M8.5.5V6.888h6.388",
    transform: "translate(2.222)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_203",
    "data-name": "Linie 203",
    x2: 6.388,
    transform: "translate(0.5 13.277)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-default-config",
    viewBox: "0 0 27 27",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamlinehq-brightness-1-interface-essential-24",
    transform: "translate(-0.501 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5863",
    "data-name": "Pfad 5863",
    d: "M9,12.813A3.813,3.813,0,1,0,12.814,9,3.813,3.813,0,0,0,9,12.813Z",
    transform: "translate(1.187 1.187)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5864",
    "data-name": "Pfad 5864",
    d: "M12,1.5V4.359",
    transform: "translate(2 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5865",
    "data-name": "Pfad 5865",
    d: "M12,20.25v2.859",
    transform: "translate(2 3.391)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5866",
    "data-name": "Pfad 5866",
    d: "M23.11,12H20.251",
    transform: "translate(3.391 2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5867",
    "data-name": "Pfad 5867",
    d: "M4.36,12H1.5",
    transform: "translate(0 2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5868",
    "data-name": "Pfad 5868",
    d: "M19.856,4.576,17.834,6.6",
    transform: "translate(2.736 0.833)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5869",
    "data-name": "Pfad 5869",
    d: "M6.6,17.834,4.576,19.856",
    transform: "translate(0.833 2.736)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5870",
    "data-name": "Pfad 5870",
    d: "M19.856,19.856l-2.022-2.022",
    transform: "translate(2.736 2.736)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5871",
    "data-name": "Pfad 5871",
    d: "M6.6,6.6,4.576,4.576",
    transform: "translate(0.833 0.833)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pricesettings",
    viewBox: "0 0 23.376 23.998",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6919",
    "data-name": "Gruppe 6919",
    transform: "translate(-0.31 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5869",
    "data-name": "Pfad 5869",
    d: "M6.879,19.188,1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5870",
    "data-name": "Pfad 5870",
    d: "M16.189,4.874a.375.375,0,0,1,0-.75",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5871",
    "data-name": "Pfad 5871",
    d: "M16.189,4.874a.375.375,0,0,0,0-.75",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5872",
    "data-name": "Pfad 5872",
    d: "M16.939,18a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,16.939,18Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5873",
    "data-name": "Pfad 5873",
    d: "M18.214,10.7l.442,1.453a.994.994,0,0,0,1.173.681l1.473-.342a1.339,1.339,0,0,1,1.274,2.219l-1.03,1.111a1,1,0,0,0,0,1.362l1.03,1.111A1.339,1.339,0,0,1,21.3,20.509l-1.473-.341a.992.992,0,0,0-1.173.681l-.44,1.451a1.331,1.331,0,0,1-2.549,0l-.442-1.452a.993.993,0,0,0-1.174-.681l-1.472.341A1.338,1.338,0,0,1,11.3,18.291l1.03-1.111a1,1,0,0,0,0-1.362L11.3,14.707a1.339,1.339,0,0,1,1.274-2.219l1.472.342a1,1,0,0,0,1.174-.681l.442-1.453a1.331,1.331,0,0,1,2.552,0Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pdf-download",
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 15V19C3 20.1 3.9 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15M17 9L12 14L7 9M12 12.8V2.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.9f6b23dab402c56b47ac3b8a927e8078.svg";
export { ForwardRef as ReactComponent };